(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('SpecialtyIbqDetailController', SpecialtyIbqDetailController);

    SpecialtyIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Specialty'];

    function SpecialtyIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Specialty) {
        var vm = this;

        vm.specialty = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:specialtyUpdate', function(event, result) {
            vm.specialty = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
